// extracted by mini-css-extract-plugin
export default {"slider":"HomePage_slider__IY-Xc","familiarity":"HomePage_familiarity__ZESbw","gift":"HomePage_gift__lenJ8"};